import Event from '@oppobrowser/lib-browser-event';
import EventEmit from '@oppobrowser/lib-browser-eventEmit';
import template from './index.dot';
import { $, $$, showToast } from '@js/utils';
import Feedback from '../../js/feedback.js';
import './index.scss';
import { postDislike } from '../../js/api';
import dislikeIconTemplate from './dislikeIcon.dot';
import shareIconTemplate from './shareIcon.dot';

const EventHandler = {
  dislike(node, event) {
    event.stopPropagation();
    if (this.dislikeSuccess) {
      return;
    }
    node.classList.add('negative-feedback__item__visited');

    postDislike()
      .then(() => {
        this.dislikeSuccess = true;
        showToast('将减少此类推荐');
      })
      .catch((error) => {
        console.error(error);
      });
    window.store.thumbUp();
  },

  share(node, event) {
    event.stopPropagation();
    if (navigator.onLine) {
      window.wv.sharePage();
    } else {
      showToast('网络连接不可用，请稍后重试');
    }
  },
};

export default class NegativeFeedback {
  constructor(el, name, data = {}) {
    this.el = el;
    this._eventHandler = {};
    this.dislikeSuccess = false; // 不喜欢反馈成功
  }

  init() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this._bindEvent();
  }

  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);

    // 点击展示全文时触发
    EventEmit.instance.on('showMore', () => {
      const negativeFeedback = $('.negative-feedback', this.el);
      negativeFeedback && negativeFeedback.classList.remove('hidden');
    });
  }

  render() {
    this.el.innerHTML = template({
      isHidden: window.store.isShowFold.isShow, // 默认隐藏 点击展开全文时才显示
      dislikeIcon: dislikeIconTemplate(),
      moreIcon: shareIconTemplate(),
    });
    const btns = $$('.negative-feedback__item', this.el);
    btns.map((el) => new Feedback(el));
    EventEmit.instance.emit('component-loaded', 'negativeFeedback', {});
  }
}
